/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const SoundIcon = ({
  width = 12,
  height = 18,
  color = '#fff',
  ...props
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.71968 16.5365L8.705 16.5241L4.63766 12.9997H2C0.895426 12.9997 -6.43727e-06 12.1043 0 10.9997L3.49284e-05 6.99967C4.13657e-05 5.89511 0.89547 4.99969 2.00004 4.99969H4.63767L8.70508 1.476L8.71968 1.46359C10.0223 0.378053 12 1.30437 12 3.00004V15.0001C12 16.6958 10.0223 17.6221 8.71968 16.5365ZM5.27813 5.76791C5.09841 5.91767 4.87188 5.99969 4.63795 5.99969H2.00004C1.44775 5.99969 1.00004 6.4474 1.00003 6.99968L1 10.9997C0.999997 11.552 1.44771 11.9997 2 11.9997H4.63795C4.87188 11.9997 5.09841 12.0817 5.27813 12.2315L9.35986 15.7683C10.0112 16.3111 11 15.8479 11 15.0001V3.00004C11 2.1522 10.0112 1.68905 9.35986 2.23181L5.27813 5.76791Z"
      fill={color}
    />
  </svg>
);

export default SoundIcon;
